import { AccessToken } from "../auth/types";
import { ComponentProps } from "react";
import { match, RouteComponentProps, RouteProps } from "react-router";
import { ICountry } from "../../types";
import { Exam } from "../exam/types";
import { WizardMode } from "../wizard/types";
import { Moment } from "moment";

export interface User {
  id?: string;
  email: string;
  name: string;
  accessToken: AccessToken;
  phone: string;
  photo: UploadedFile;
  role: number;
  verified: boolean;
  studentProfile: StudentProfile;
  agentProfile: AgentProfile;
  schoolProfile: SchoolProfile;
  passwordSet: boolean;
  created_at: Date;
  favorites: any;
  profile_verified?: boolean;
  // majors: Exam[],
}

export interface StudentProfile {
  id?: string;
  country: string | ICountry;
  city: string;
  country_name: string;
  citizenship: string | ICountry;
  citizenship_name: string | ICountry;
  birth_date: string;
  passport: UploadedFile;
  references: UploadedFile;
  resume: UploadedFile;
  transcript: UploadedFile;
  diploma: UploadedFile;
  motivationLetter: UploadedFile;
  examCertificate: UploadedFile;
  credits: number;
  agent: AgentProfile;
  filled: number;
  exams: PassedExam[];
}

export interface AgentProfile {
  id?: string;
  name: string;
  address: string;
  website: string;
  title: string;
  students?: StudentProfile[];
}

export interface ParentProfile {
  id: string;
  credits: number;
  students?: StudentProfile[];
}

export interface SchoolProfile {
  school: {
    id?: string;
    name: string;
    address: string;
    website: string;
    title: string;
    image?: {
      preview: string;
    };
  };
}

export interface UploadedFile {
  preview: string;
  bucket: string;
  etag: string;
  id: string;
  mimetype: string;
  name: string;
  path: string;
}

export interface PassedExam {
  id: string;
  examId?: string;
  value: number;
  exam?: Exam;
}

export interface WithUserProps extends ComponentProps<any> {
  user: User;
}

export interface WithUsersProps extends ComponentProps<any> {
  users: User[];
}

export interface WithUserIdProps extends ComponentProps<any> {
  userId: string;
}

export interface UsersListProps extends RouteProps {
  loaded: boolean;
  users: User[];
  loadUsers: Function;
}

export interface UsersListItemProps extends RouteProps {
  user: User;
}

export interface ShowUserProps extends RouteComponentProps {
  computedMatch: match;
  loaded: boolean;
  loadUsers: Function;
  user: User;
}

export interface IStudentFrontEndModel {
  email: string;
  mode: WizardMode;
  name: string;
  phone: string;
  image?: string;
  studentProfile: {
    birth_date: Moment;
    citizenship?: {
      code: string;
      name: string;
    };
    city: string;
    country?: {
      code: string;
      name: string;
    };
    gender?: {
      id: Gender;
      name: string;
    };
  };
}

export enum Gender {
  Male = 1,
  Female = 2,
  Other = 3,
}

export const GENDER = [
  {
    id: Gender.Male,
    name: "Male",
  },
  {
    id: Gender.Female,
    name: "Female",
  },
  {
    id: Gender.Other,
    name: "Other",
  },
];
